<template>
  <div>
    <Modal title="快速入口" :value="value" @on-visible-change="change_s">
      <CheckboxGroup v-model="selection">
        <span v-for="item in report_list" :key="item.id">
          <Checkbox :label="item.id" class="checkbox-item" :class="{'checked-item': selection.indexOf(item.title) !== -1}">
            <span>{{item.title}}</span>
          </Checkbox>
        </span>
      </CheckboxGroup>
      <div slot="footer">
        <Button @click="cancel">取消</Button>
        <Button @click="confirm" type="primary">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import qs from 'qs'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    report_list: {
      type: Array
    },
    roleId: Number
  },
  data(){
    return {
      selection: []
    }
  },
  methods: {
    selected(id) {
      this.selection = []
      ajax.get(requestUrls.AbpReportSysSetting.GetListByRoleId,{
        params: {
          roleIds: [id],
        },
        paramsSerializer: params => {
          return qs.stringify(params, { indices: false })
        }
      }).then(res => {
        res.data.result.items.forEach(item => {
          this.selection.push(item.id)
        })
      })
    },
    async confirm(){
      ajax.put(requestUrls.AbpReportSysSetting.UpdateRoleManyReportSys + `?role_id=${this.roleId}`, this.selection).then(res => {
        this.$Message.success('绑定成功')
      })
      this.$emit('save-success')
    },
    cancel(){
      this.$emit('save-success')
    },
    change_s(val){
      if(!val){
        this.$emit('save-success')
      }
    }
  }
}
</script>
<style lang="less" scoped>
// 修改checkbox样式
.checkbox-item {
  border: 1px solid #ddd;
  padding: 5px 10px;
  border-radius: 5px;
  margin: 5px;
  &:hover {
    border-color: #2d8cf0;
  }
}
.checked-item {
  border-color: #2d8cf0;
}
/deep/ .ivu-modal-body {
  height: 200px;
}
</style>
